var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.166 8.833 12.999 8a2.828 2.828 0 1 0-4-4l-.833.833M5.834 7.167 5 8a2.828 2.828 0 1 0 4 4l.834-.834M10.5 6.5l-3 3",
    stroke: "#808085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgLink;